import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { EventService } from '../../services/event.service';
import { ThemeService } from '../../services/theme.service';
import { IEventItem } from '../../models/IEventItem';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss']
})
export class EventDetailsComponent implements OnInit, OnDestroy {
  event$: Observable<any>;
  theme$: Observable<any>;
  subscription: Subscription;
  PLACEHOLDER_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/froodini-d5dad.appspot.com/o/placeholder.jpg?alt=media&token=16ef0fe2-9a67-4fef-91ef-1910417ec165';

  constructor(private routes: ActivatedRoute, private eventService: EventService, private themeServcie: ThemeService) { }

  ngOnInit(): void {
    const id = this.routes.snapshot.params.id;
    this.event$ = this.eventService.get(id);
    this.subscription = this.event$.subscribe(r => this.theme$ = this.themeServcie.get(r.theme));
  }

  getImage(image: any) {
    return image != null ? image : this.PLACEHOLDER_IMAGE;
  }

  getParticipantItems(name: string, items: IEventItem[]) {
    return items.filter(i => i.provider === name);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
